export const LOGO = {
    src: "/seedkit_admin_logo_black.svg",
    width: 113,
    height: 52,
    alt: "Seedkit Admin logo"
}

export const TOTAL_OPTIONS_YEARS = 50;

export const EMPTY_OPTION = { value: "", label: "" };

export const EMPTY_TAGGED_OPTION = { value: "", label: "", tags: [] };

/* Table Actions */

export const ActionKeys = {
    ADD: "add",
    EDIT: "edit",
    DUPLICATE: "duplicate",
    DELETE: "delete",
    NOTIFY: "notify",
    ENABLE: "enable",
    REMOVE: "remove",
    UNSUBSCRIBE: "unsubscribe"
};

/* Data Extract Constants */

export const DataExtractTypes = {
    SNAPSHOT: "snapshot",
    ORGS: "orgs",
    TRIAL_ORGS: "trialorgs",
    SOCIAL_ENTERPRISES: "enterprises",
    PROGRAMS: "programs",
    PROJECTS: "projects",
    INDICATORS: "indicators"
};

export const EXPORT_COLUMNS_ALL = "All";

export const DATA_EXTRACT_OPTIONS = [
    { 
        value: "", 
        label: "",
        startTip: "",
        endTip: "",
        exportColumns: EXPORT_COLUMNS_ALL
    },
    { 
        value: DataExtractTypes.SNAPSHOT, 
        label: "Overall snapshot",
        startTip: "Based on organisation accounts created on or after this date", 
        endTip: "Based on organisation accounts created on or before this date",
        exportColumns: ["name", "value"]
    },
    { 
        value: DataExtractTypes.ORGS, 
        label: "Registered full-account organisation details",
        startTip: "Includes organisation accounts created on or after this date",
        endTip: "Includes organisation accounts created on or before this date",
        exportColumns: EXPORT_COLUMNS_ALL
    },
    { 
        value: DataExtractTypes.TRIAL_ORGS, 
        label: "Trial-account organisation details", 
        startTip: "Includes organisation accounts created on or after this date",
        endTip: "Includes organisation accounts created on or before this date",
        exportColumns: EXPORT_COLUMNS_ALL 
    },
    { 
        value: DataExtractTypes.SOCIAL_ENTERPRISES, 
        label: "Social enterprise profile data", 
        startTip: "Includes social enterprises created on or after this date",
        endTip: "Includes social enterprises created on or before this date",
        exportColumns: EXPORT_COLUMNS_ALL 
    },
    { 
        value: DataExtractTypes.PROGRAMS, 
        label: "Program profile data", 
        startTip: "Includes programs created on or after this date",
        endTip: "Includes programs created on or before this date",
        exportColumns: EXPORT_COLUMNS_ALL
    },
    { 
        value: DataExtractTypes.PROJECTS, 
        label: "Project profile data", 
        startTip: "Includes projects created on or after this date",
        endTip: "Includes projects created on or before this date",
        exportColumns: EXPORT_COLUMNS_ALL 
    },
    { 
        value: DataExtractTypes.INDICATORS, 
        label: "Indicator report", 
        startTip: "Based on the date the indicator's reporting unit was created",
        endTip: "Based on the date the indicator's reporting unit was created",
        exportColumns: EXPORT_COLUMNS_ALL 
    },
]

/* Learning Resource Constants */

export const ResourceStrapLabels = {
    VIEW_ONLY: "This page is in view only mode, press edit to change resource details.",
    EDIT: "You can edit the resource details on this page."
};

export const ResourceType = {
    TEXT: "Text",
    VIDEO: "Video",
    POWERPOINT: "Powerpoint"
};

export const RESOURCE_TYPE_OPTIONS = [
    EMPTY_OPTION,
    { value: ResourceType.TEXT, label: "Text Article" },
    { value: ResourceType.VIDEO, label: "Video" },
    { value: ResourceType.POWERPOINT, label: "Powerpoint Presentation" }
];

export const ResourceCategory = {
    ALL: "All",
    NEWS: "News",
    LEARN: "Learn",
    HOW_TO: "HowTo",
    NOT_SET: "NOT SET"
};

export const RESOURCE_CATEGORY_OPTIONS = [
    EMPTY_OPTION,
    { value: ResourceCategory.NEWS, label: "News" },
    { value: ResourceCategory.LEARN, label: "Learn" },
    { value: ResourceCategory.HOW_TO, label: "HowTo" }
];

export const ResourceAccessType = {
    PUBLIC: "public",
    AUTHENTICATED: "authenticated"
};

export const RESOURCE_ACCESS_OPTIONS = [
    { value: ResourceAccessType.PUBLIC, label: "Public" },
    { value: ResourceAccessType.AUTHENTICATED, label: "Private (Only Accessible to Logged In Users)" },
];

export const ResourceStatus = {
    DRAFT: "draft",
    PUBLISHED: "published",
    UNPUBLISHED: "unpublished"
}

export const LEAD_TEXT = "The first paragraph of the article and the paragraph that appears in resource listings";
export const LEAD_MEDIA = "The paragraph that appears under the embedded media and the paragraph that appears in resource listings";

export const EDIT_BUTTON_LABEL = "Edit";
export const DONE_BUTTON_LABEL = "Done";

/* Tag Colors */

export const TagColor = {
    GREEN: "green",
    YELLOW: "yellow",
    PURPLE: "purple",
    GREY: "grey",
    BLACK_OUTLINE: "black-outline",
    BLUE: "blue"
}

/* Mail List Constants */

export const MAIL_LIST_ACTIONS = [
    {
        type: "action",
        key: ActionKeys.REMOVE,
        leftIcon: "BarsArrowDownIcon",
        label: "Remove",
        headerLabel: "Remove From List",
        variant: "default"
    },
    {
        type: "action",
        key: ActionKeys.UNSUBSCRIBE,
        leftIcon: "TrashIcon",
        label: "Unsubscribe",
        variant: "red"
    }
];

/* Powerpoint Constants */

export const POWERPOINT_DELETE_ERROR = "An error occurred deleting the saved Powerpoint file.";
export const POWERPOINT_UPLOAD_ERROR = "An error occurred uploading your Powerpoint file.";
